import {fileUtil, paginationUtil} from '../../../utils';
import profileService from './profile.service';
import BaseStore from '../base.store';
import {makeObservable} from 'mobx';

class ProfileStore extends BaseStore {

    constructor() {
        super();

        makeObservable(this, {});

        this.createInitialState();
    }

    getPageableProfiles = ({startDate, endDate}, accountId = undefined, contactId = undefined) =>
        (currentPage, pageSize, sortingFields, filter, tableSelectCallback) => {

        const params = {
            accountId: accountId,
            contactId: contactId,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            page: currentPage,
            size: pageSize,
            filter: filter,
            sort: paginationUtil.createSingleSortingParameter(sortingFields)
        };

        return profileService.getPageableProfiles(params)
            .then(({data}) => {
                tableSelectCallback(data);
            });
    };

    exportToCsv = ({startDate, endDate}, filter, {accountId, accountName} = {}, {contactId, contactName} = {}) => {
        const params = {
            accountId: accountId,
            contactId: contactId,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            filter
        };

        let fileName;

        if (accountName) {
            fileName = `Account profiles ${accountName}`;
        } else if (contactName) {
            fileName = `User profiles ${contactName}`;
        } else {
            fileName = 'Encompass profiles';
        }

        fileName = `${fileName} ${startDate.format('DD.MM.YYYY')} - ${endDate.format('DD.MM.YYYY')}`;

        return profileService.getProfileCSV(params)
            .then(({data}) => {
                fileUtil.download(data, fileName, '.csv');
            });
    };
}

const profileStore = new ProfileStore()
export default profileStore;